import { Controller } from "@hotwired/stimulus"

import Swiper from 'swiper';

import { Navigation, Pagination } from "swiper/modules";

// Connects to data-controller="swiper"
export default class extends Controller {
  connect() {
    if (this.element.querySelectorAll(".featured-news__item").length > 1) {
      this.initSwiper();
    }
  }
  initSwiper() {
    this.swiper = new Swiper(this.element, {
      direction: 'horizontal',
      spaceBetween: 30,
      modules: [Navigation, Pagination],
      breakpoints: {
        768: {
          navigation: {
            enabled: true,
          },
          pagination: {
            enabled: false,
          },
        },
      },
      navigation: {
        enabled: false,
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      pagination: {
        enabled: true,
        el: '.swiper-pagination',
        clickable: true,
      },
    });
  }
}
